import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[#222] bg-[#050505] px-6 md:px-16 lg:px-32 py-12"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div className="flex flex-col gap-3">
          <div data-testid="footer-logo" className="font-display text-xl font-bold tracking-tighter uppercase">
            Podcast<span className="text-[#F4C75E] ml-2">Studio</span>
          </div>
          <a
            href="mailto:contact@podcastproduction.studio"
            data-testid="footer-email"
            className="group inline-flex items-center gap-2.5 text-sm text-[#A3A3A3] hover:text-[#F4C75E] transition-colors w-fit"
          >
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-[#F4C75E]/30 text-[#F4C75E] group-hover:border-[#F4C75E] transition-colors">
              <Mail className="w-4 h-4" />
            </span>
            contact@podcastproduction.studio
          </a>
        </div>

        <div className="flex flex-col md:items-end gap-2">
          <div
            data-testid="footer-attribution"
            className="text-xs uppercase tracking-[0.25em] text-[#999]"
          >
            A Product of <span className="text-[#F4C75E] font-semibold">Sonyk Media</span>
          </div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#666]">
            © 2026 · All Cuts Reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
